<template>
  <div
    class="min-w-60 flex-col flex-1 justify-start text-center items-center gap-3 inline-flex mb-3 md:mb-0"
  >
    <img
      v-if="image !== null"
      :src="image.src"
      :width="image.width"
      :height="image.height"
      :alt="image.alt"
    />
    <div class="text-black md:text-lg font-medium">{{ title }}</div>
    <div class="text-center text-black text-sm">{{ description }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },

    description: {
      type: String,
    },

    image: {
      type: Object,
    },
  },
};
</script>
